import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import "@/App.css";

import { Topbar, Footer, MobileStickyBar, useReveal } from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import ModelDetailPage from "@/pages/ModelDetailPage";
import CatalogPage from "@/pages/CatalogPage";
import NotFoundPage from "@/pages/NotFoundPage";
import PonudeLoginPage from "@/pages/PonudeLoginPage";
import PonudeAppPage from "@/pages/PonudeAppPage";
import AuthCallback from "@/pages/AuthCallback";
import { AuthProvider } from "@/context/AuthContext";

// Scroll to hash anchor on navigation, otherwise to top
function ScrollManager() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash && !hash.includes("session_id=")) {
            const el = document.querySelector(hash);
            if (el) {
                setTimeout(() => el.scrollIntoView({ behavior: "smooth", block: "start" }), 50);
                return;
            }
        }
        window.scrollTo(0, 0);
    }, [pathname, hash]);
    return null;
}

function PublicShell({ children }) {
    useReveal();
    return (
        <div className="App pb-[60px] lg:pb-0">
            <Topbar />
            <main>{children}</main>
            <Footer />
            <MobileStickyBar />
        </div>
    );
}

function AppRouter() {
    const location = useLocation();

    // CRITICAL: Synchronously detect OAuth callback before any other route logic
    if (location.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }

    return (
        <>
            <ScrollManager />
            <Routes>
                {/* Public site */}
                <Route path="/" element={<PublicShell><HomePage /></PublicShell>} />
                <Route path="/modeli/:id" element={<PublicShell><ModelDetailPage /></PublicShell>} />
                <Route path="/katalog" element={<PublicShell><CatalogPage /></PublicShell>} />

                {/* Quote app (auth-gated) */}
                <Route path="/ponude/login" element={<PonudeLoginPage />} />
                <Route path="/ponude" element={<PonudeAppPage />} />

                <Route path="*" element={<PublicShell><NotFoundPage /></PublicShell>} />
            </Routes>
        </>
    );
}

export default function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AuthProvider>
                    <Toaster position="top-right" richColors closeButton />
                    <AppRouter />
                </AuthProvider>
            </BrowserRouter>
        </HelmetProvider>
    );
}
